import { render, staticRenderFns } from "./ReservationPreorderDetailPage.vue?vue&type=template&id=398519c6&scoped=true&lang=pug&"
import script from "./ReservationPreorderDetailPage.vue?vue&type=script&lang=js&"
export * from "./ReservationPreorderDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./ReservationPreorderDetailPage.vue?vue&type=style&index=0&id=398519c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398519c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCol,VContainer,VDivider,VIcon,VOverlay,VProgressCircular,VRow,VSkeletonLoader})
